'use client'
import { useState } from 'react'
import { Link, Mail, Phone } from 'lucide-react'
import { CONTACT_BRANDS, type ContactIcon, type ContactIconPreset } from '@/lib/agents/messaging/channels/web-widget/contact-channels/model'

type Props = { provider: ContactIconPreset; icon?: ContactIcon; imageUrl?: string; compact?: boolean }
export function ContactChannelIcon({ provider, icon, imageUrl, compact = false }: Props) {
  const [failed, setFailed] = useState<string | null>(null)
  const preset = icon?.kind === 'preset' ? icon.provider : provider
  const brand = CONTACT_BRANDS[preset]
  const src = imageUrl && failed !== imageUrl ? imageUrl : brand.src
  const size = compact ? 32 : 44
  const artwork = compact ? 18 : 24
  let glyph = <Link size={artwork} aria-hidden />
  if (preset === 'email') glyph = <Mail size={artwork} aria-hidden />
  if (preset === 'phone') glyph = <Phone size={artwork} aria-hidden />
  return <span style={{ width: size, height: size, flexShrink: 0, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: imageUrl ? '#f1f5f9' : `${brand.color}18`, color: brand.color }}>
    {src && failed !== src ? (
      // eslint-disable-next-line @next/next/no-img-element -- shared renderer also runs in the standalone widget iframe
      <img src={src} alt="" width={artwork} height={artwork} style={{ width: artwork, height: artwork, objectFit: 'contain', display: 'block' }} onError={() => setFailed(src)} />
    ) : glyph}
  </span>
}
